export default "__VITE_ASSET__DS9BameD__"